module.exports = __webpack_public_path__ + "img/Gezeichnet.ee41bd08.jpg";